import { useState, useEffect } from 'react';
import { Lock } from 'lucide-react';
import { META, ROUTES } from './data';

// Westmoreland Header — broadsheet masthead. Top "edition" line + central title +
// bottom navigation in a single thin row. Looks like a serious newspaper.
export default function Header({ page, setPage }) {
  const [scrolled, setScrolled] = useState(false);
  const [today] = useState(new Date().toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }));
  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', h, { passive: true });
    return () => window.removeEventListener('scroll', h);
  }, []);
  return (
    <header className={`sticky top-0 z-40 bg-[#EFEAE0] border-b border-[#1B1A18]/15 transition-all duration-700 ${scrolled ? 'py-1' : ''}`}>
      {/* Edition line */}
      <div className="border-b border-[#1B1A18]/10 hidden md:block">
        <div className="max-w-[1500px] mx-auto px-8 lg:px-14 h-7 flex items-center justify-between font-mono text-[10px] tracking-[0.25em] uppercase text-[#1B1A18]/55">
          <span>Edition · {today}</span>
          <span className="flex items-center gap-2"><Lock className="w-3 h-3" strokeWidth={1.5} /> Members only</span>
          <span>London · Zürich · New York · Singapore</span>
        </div>
      </div>
      {/* Masthead */}
      {!scrolled && (
        <div className="max-w-[1500px] mx-auto px-8 lg:px-14 py-5 text-center border-b border-[#1B1A18]/15">
          <button onClick={() => setPage('home')} data-testid="bank-logo" className="inline-block">
            <p className="font-serif text-4xl lg:text-6xl text-[#142437] tracking-tight">{META.brand}</p>
            <p className="font-serif italic text-base text-[#1B1A18]/55 mt-1">{META.tagline}</p>
          </button>
        </div>
      )}
      {/* Nav row */}
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 h-12 flex items-center justify-between gap-6">
        {scrolled && (
          <button onClick={() => setPage('home')} className="font-serif text-2xl text-[#142437]" data-testid="bank-logo-compact">{META.brand}</button>
        )}
        <nav className={`flex items-center gap-8 ${scrolled ? '' : 'mx-auto'}`}>
          {ROUTES.map(r => (
            <button key={r.id} onClick={() => setPage(r.id)} data-testid={`bank-nav-${r.id}`}
              className={`font-mono text-[11px] tracking-[0.22em] uppercase transition-colors ${page === r.id ? 'text-[#142437] border-b-2 border-[#142437]' : 'text-[#1B1A18]/55 hover:text-[#142437]'}`}>
              {r.label}
            </button>
          ))}
        </nav>
        <button onClick={() => setPage('introduce')} className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#142437] hover:underline hidden md:block" data-testid="bank-cta-introduce">
          Request introduction →
        </button>
      </div>
    </header>
  );
}
